import React from 'react';

import PropTypes from 'prop-types';

import {
  NaviagationButtons,
  NaviagationButtonText,
  ActivePage,
  PageButtons
} from '../../../salesRepDashboard/css';

import { PaginationWrapper, PaginationContainer } from './css';

const Pagination = ({ count, currentPage, setPage }) => {
  const maxPages = 5;
  const totalPages = Math.ceil(count / 50);

  const getPages = () => {
    let startPage;
    let endPage;

    if (totalPages <= maxPages) {
      startPage = 1;
      endPage = totalPages;
    } else {
      const maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
      const maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
      if (currentPage <= maxPagesBeforeCurrentPage) {
        startPage = 1;
        endPage = maxPages;
      } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
        startPage = totalPages - maxPages + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - maxPagesBeforeCurrentPage;
        endPage = currentPage + maxPagesAfterCurrentPage;
      }
    }

    const pages = Array.from(Array(endPage + 1 - startPage).keys()).map(
      i => startPage + i
    );
    return pages;
  };

  if (totalPages === 1) return null;

  return (
    <PaginationWrapper>
      <PaginationContainer>
        {currentPage > 1 && (
          <NaviagationButtons
            onClick={() => {
              setPage(currentPage - 1);
            }}
          >
            <NaviagationButtonText>«</NaviagationButtonText>
          </NaviagationButtons>
        )}

        {getPages().map(pageNumber =>
          pageNumber === currentPage ? (
            <ActivePage
              onClick={() => {
                setPage(pageNumber);
              }}
            >
              {pageNumber}
            </ActivePage>
          ) : (
            <PageButtons
              onClick={() => {
                setPage(pageNumber);
              }}
            >
              {pageNumber}
            </PageButtons>
          )
        )}
        {currentPage < totalPages && (
          <NaviagationButtons
            onClick={() => {
              setPage(currentPage + 1);
            }}
          >
            <NaviagationButtonText>»</NaviagationButtonText>
          </NaviagationButtons>
        )}
      </PaginationContainer>
    </PaginationWrapper>
  );
};

Pagination.propTypes = {
  count: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired
};

export default Pagination;
